import { EDIT_PAGES } from "../actions/pagesActions";

const initialState = {};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EDIT_PAGES:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default reducer;
